import React, { ReactNode } from 'react'
import { createBrowserRouter, RouterProvider, RouteObject } from 'react-router-dom'
import { Route } from './routes/Route'
import routeConfig from './routes/routeConfig'
import 'antd/dist/reset.css'
import GlobalStyle from './config/GlobalStyle'
import { filterRoute } from './utils/helpers'

const cloneRoute = (route: Route, element: React.ReactElement): ReactNode => {
  return React.cloneElement(element, { route: filterRoute(route, r => !!r.path) })
}

const map = (route: Route): RouteObject => {
  const routeObject = {
    path: route.path,
    handle: { ...route.handle, authority: route.authority },
    loader: route.loader,
    errorElement: route.errorElement,
    action: route.action,
    element: route.element ? cloneRoute(route, route.element) : undefined
  }

  // Index routes can't have children, so react-router types them separately. An index route's path is
  // only its menu key (same as its parent's path), so it isn't passed to the router.
  if (route.index) return { ...routeObject, path: undefined, index: true }
  return { ...routeObject, index: false, children: route.routes?.map(map) }
}

const routes = routeConfig.map(map)
const router = createBrowserRouter(routes)

const AppRouter: React.FC = () => {
  return (
    <>
      <GlobalStyle />
      <RouterProvider router={router} />
    </>
  )
}

export default AppRouter
